// @flow
import * as React from "react";

type Props = {
  width?: number,
  className?: string
};

const BonusTimer = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 124.002"
    width={props.width || "120px"}
    className={props.className}
  >
    <path
      fillOpacity="0.1"
      d="M117.638,53.153a10.033,10.033,0,0,1-1.766-8.88,11.107,11.107,0,0,0-5.242-12.656,10.03,10.03,0,0,1-5.03-7.528A11.106,11.106,0,0,0,95.914,14.4a10.031,10.031,0,0,1-7.528-5.03A11.106,11.106,0,0,0,75.73,4.131a10.031,10.031,0,0,1-8.88-1.766,11.106,11.106,0,0,0-13.7,0,10.031,10.031,0,0,1-8.88,1.766A11.107,11.107,0,0,0,31.617,9.373a10.03,10.03,0,0,1-7.528,5.03A11.107,11.107,0,0,0,14.4,24.089a10.031,10.031,0,0,1-5.03,7.528A11.106,11.106,0,0,0,4.131,44.273a10.032,10.032,0,0,1-1.766,8.88,11.107,11.107,0,0,0,0,13.7,10.032,10.032,0,0,1,1.766,8.88A11.107,11.107,0,0,0,9.373,88.387a10.03,10.03,0,0,1,5.03,7.528,11.106,11.106,0,0,0,9.686,9.686,10.032,10.032,0,0,1,7.528,5.03,11.106,11.106,0,0,0,12.656,5.242,10.031,10.031,0,0,1,8.88,1.766,11.106,11.106,0,0,0,13.7,0,10.031,10.031,0,0,1,8.88-1.766,11.106,11.106,0,0,0,12.656-5.242,10.03,10.03,0,0,1,7.528-5.03,11.106,11.106,0,0,0,9.686-9.686,10.031,10.031,0,0,1,5.03-7.528,11.106,11.106,0,0,0,5.242-12.656,10.032,10.032,0,0,1,1.766-8.88A11.107,11.107,0,0,0,117.638,53.153Z"
      transform="translate(-0.001 3.999)"
    />
    <path
      fill="currentColor"
      d="M117.638,53.153a10.033,10.033,0,0,1-1.766-8.88,11.107,11.107,0,0,0-5.242-12.656,10.03,10.03,0,0,1-5.03-7.528A11.106,11.106,0,0,0,95.914,14.4a10.031,10.031,0,0,1-7.528-5.03A11.106,11.106,0,0,0,75.73,4.131a10.031,10.031,0,0,1-8.88-1.766,11.106,11.106,0,0,0-13.7,0,10.031,10.031,0,0,1-8.88,1.766A11.107,11.107,0,0,0,31.617,9.373a10.03,10.03,0,0,1-7.528,5.03A11.107,11.107,0,0,0,14.4,24.089a10.031,10.031,0,0,1-5.03,7.528A11.106,11.106,0,0,0,4.131,44.273a10.032,10.032,0,0,1-1.766,8.88,11.107,11.107,0,0,0,0,13.7,10.032,10.032,0,0,1,1.766,8.88A11.107,11.107,0,0,0,9.373,88.387a10.03,10.03,0,0,1,5.03,7.528,11.106,11.106,0,0,0,9.686,9.686,10.032,10.032,0,0,1,7.528,5.03,11.106,11.106,0,0,0,12.656,5.242,10.031,10.031,0,0,1,8.88,1.766,11.106,11.106,0,0,0,13.7,0,10.031,10.031,0,0,1,8.88-1.766,11.106,11.106,0,0,0,12.656-5.242,10.03,10.03,0,0,1,7.528-5.03,11.106,11.106,0,0,0,9.686-9.686,10.031,10.031,0,0,1,5.03-7.528,11.106,11.106,0,0,0,5.242-12.656,10.032,10.032,0,0,1,1.766-8.88A11.107,11.107,0,0,0,117.638,53.153Z"
      transform="translate(-0.001 -0.001)"
    />
  </svg>
);

export default BonusTimer;



// WEBPACK FOOTER //
// ./src/components/Icons/BonusTimer.js